import { render, staticRenderFns } from "./PlantAlarmStatics.vue?vue&type=template&id=c0cc4abe&scoped=true&"
import script from "./PlantAlarmStatics.vue?vue&type=script&lang=js&"
export * from "./PlantAlarmStatics.vue?vue&type=script&lang=js&"
import style0 from "./PlantAlarmStatics.vue?vue&type=style&index=0&id=c0cc4abe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cc4abe",
  null
  
)

export default component.exports